const PRIMARY = 'MMMM dd, yyyy'
const SECONDARY = 'yyyy-MM-dd HH:mm'

export const DATE_MASK = {
  PRIMARY,
  SECONDARY,
}
